import clsx from 'clsx';

import { useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import DrawerSkeleton from '..';
import CommonCard from '../../Components/General/CommonCard';
import Button from '../../Components/UI/Button';
import { paymentsOptions } from '../../data';
import DrawerHeader from '../DrawerHeader';
import classes from './PaymentMethodDrawer.module.css';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
const PaymentMethodDrawer = ({ show, setShow, onSubmit, data, setSelectedPackage }) => {
  const [selectedMethod, setSelectedMethod] = useState(-1);
  const state = useSelector((state) => state);

  const onCancel = () => {
    setSelectedMethod(-1);
    setSelectedPackage(null);
    setShow();
  };
  const handleSubmit = (e) => {
    e.preventDefault();

    if (!selectedMethod?.title) {
      return toast.error('Please select payment method');
    }
    if (typeof onSubmit === 'function') {
      onSubmit({ packageId: data, paymentMode: selectedMethod?.title }, onCancel);
    }
  };
  return (
    <>
      <DrawerSkeleton
        setShow={() => {
          setSelectedPackage(null);
          onCancel();
        }}
        show={show}>
        <div className={classes.wrapper}>
          <DrawerHeader
            prev={false}
            title={'Payments'}
            setShow={() => {
              setSelectedMethod(-1);
              setShow();
            }}
          />
          <form onSubmit={handleSubmit} className={clsx(classes.mainWrapper, 'scrollbar1')}>
            <div>
              <Row className={classes.controlsGrid}>
                {paymentsOptions?.map((data) => (
                  <Col key={data?.id} xs={12}>
                    <CommonCard
                      className={clsx({
                        [classes.selectedMethod]: selectedMethod?.id === data?.id
                      })}
                      onClick={() => {
                        setSelectedMethod(data);
                      }}>
                      <div className={classes.paymentMethodCard}>
                        <CommonCard className={classes.methodImgWrapper}>{data?.icon}</CommonCard>
                        <p className={classes.paymentName}>{data?.title}</p>
                      </div>
                    </CommonCard>
                  </Col>
                ))}
              </Row>
            </div>

            <div className={classes.bottomAction}>
              <Button
                label={'Close'}
                variants="secondary"
                onClick={() => {
                  setSelectedPackage(null);
                  setShow();
                  onCancel();
                }}
              />
              <Button type="submit" label={'Confirm'} variants="primary" />
            </div>
          </form>
        </div>
      </DrawerSkeleton>
    </>
  );
};

export default PaymentMethodDrawer;
